import React from 'react';
import PropTypes from 'prop-types';
import { QQShare } from 'ThreeTerminal_mobile';
import errorBoundary from '@ifeng-fe/errorBoundary';

class TwiceShare extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;
        const qqShareCofig = content;

        return <React.Fragment>{qqShareCofig.title && <QQShare content={qqShareCofig} />}</React.Fragment>;
    }
}

export default errorBoundary(TwiceShare);
